var _path, _circle, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBoxFreshSmartphone = function SvgBoxFreshSmartphone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m70.16 12-19-3H41a1 1 0 0 0-1 1v2H10a1 1 0 0 0-1 1v54a1 1 0 0 0 1 1h30v2a1 1 0 0 0 1 1h10.16l19-3a1 1 0 0 0 .84-1V13a1 1 0 0 0-.84-1M11 66V14h29v52Zm31-55h8v58h-8Zm27 55.15-17 2.68V11.17l17 2.68Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26,
    cy: 53,
    r: 1.3,
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M32.56 19.5H19.44a4.92 4.92 0 0 0-4.94 4.9v31.2a4.92 4.92 0 0 0 4.94 4.9h13.12a4.92 4.92 0 0 0 4.94-4.9V24.4a4.92 4.92 0 0 0-4.94-4.9m2.94 36.1a2.92 2.92 0 0 1-2.94 2.9H19.44a2.92 2.92 0 0 1-2.94-2.9V24.4a2.92 2.92 0 0 1 2.94-2.9h13.12a2.92 2.92 0 0 1 2.94 2.9Z"
  })));
};
export default SvgBoxFreshSmartphone;